import React from "react";
import { Link } from "react-router-dom";
import styles from "./Logo.module.css";
import logoSrc from "@/assets/edudata_logo_completo.png";
import type { logoProps } from "./types.props";

const Logo: React.FC<logoProps> = ({
    to = "/",
    alt = "EDUDATA",
    className = "",
}) => (
    <Link to={to} className={`${styles.wrapper} ${className}`}>
        <img src={logoSrc} alt={alt} className={styles.image} />
    </Link>
);

export default Logo;
